/// <amd-module name="Build/Pipelines/PipelinesHeaderBreadcrumbService" />
import { IReadonlyObservableArray, ObservableArray } from "VSS/Core/Observable";
import { Services, VssService } from "VSS/Platform/Context";
import { onClickFPS } from "VSS/Platform/FPS";

import { IBuildLinkingService } from "Build/Client/Linking";
import { IBreadcrumbItemService } from "VSS/Features/PlatformUI/ContributedBreadcrumb";
import { IBreadcrumbItem } from "VSSUI/Breadcrumb.Types";

export class PipelinesHeaderBreadcrumbService extends VssService implements IBreadcrumbItemService {
    private items = new ObservableArray<IBreadcrumbItem>();

    public getBreadcrumbItems(breadcrumbId: string): IReadonlyObservableArray<IBreadcrumbItem> {
        return this.items;
    }

    public setPipeline(name: string, url: string, definitionPath: string) {
        this.items.removeAll();
        const linkingService = this.pageContext.getService<IBuildLinkingService>("IBuildLinkingService");
        const folderNames = definitionPath.split("\\").filter(Boolean);
        let folderPath = "";
        for (let i = 0; i < folderNames.length; i++) {
            folderPath += `\\${folderNames[i]}`;
            const folderUrl = linkingService.getFolderUrl(folderPath);
            this.items.push({
                key: `pipeline-path-breadcrumb-${i}`,
                text: folderNames[i],
                href: folderUrl,
                onClick: ev => {
                    onClickFPS(this.pageContext, folderUrl, true, ev, { telemetrySource: "pipelines-breadcrumb" });
                }
            });
        }

        this.items.push({
            key: "pipeline-breadcrumb",
            text: name,
            href: url,
            onClick: ev => {
                onClickFPS(this.pageContext, url, true, ev, { telemetrySource: "pipelines-breadcrumb" });
            }
        });
    }

    public clearPipeline() {
        this.items.removeAll();
    }
}

Services.add("pipelines-header-breadcrumb-service", { serviceFactory: PipelinesHeaderBreadcrumbService });
